import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { RequestService } from 'app/core/services/request.service';
import { ConfigService } from 'app/core/services/config.service';

@Injectable()
export class CompanyService {

    constructor(
        private requestService: RequestService,
        private configService: ConfigService
    ) {
    }

    addCompany(data: any): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').solar.company.add.api;
        return this.requestService.post(url, data);
    }

    listCompaniesDictionary(): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').solar.company.dictionary.api;
        return this.requestService.get(url);
    }
}


// WEBPACK FOOTER //
// ./src/app/solar/common/services/company.service.ts